<template>
  <div>
    <h1 class="mb-8 text-3xl font-bold">
      <Link
        class="text-indigo-400 hover:text-indigo-600"
        :href="route('eos.index')">
        Verifikasi Akhir Studi
      </Link>
      <span class="font-medium text-indigo-400">/</span>
      <Link
        class="text-indigo-400 hover:text-indigo-600"
        :href="route('mahasiswa.edit', eosRecord.mahasiswa.id)">
        {{ eosRecord.mahasiswa.name }}
      </Link>
    </h1>
    <trashed-message
      v-if="eosRecord.deleted_at"
      class="mb-6"
      @restore="restore">
      This record AkhirStudi has been deleted.
    </trashed-message>
    <div class="overflow-hidden w-full bg-white rounded-md shadow md:w-2/3">
      <div class="flex justify-between">
        <div class="pt-4 px-8">
          <ToggleButton label="Akhir Studi" v-model="isActive" />
        </div>
        <span class="text-lg font-semibold pt-4 px-8">
          [ Verifikasi aktif: {{ formatDate(eosRecord.eos_verified_at) }} ]
        </span>
      </div>
      <div class="divider" />
      <div class="w-full flex justify-end px-8">
        <span class="font-bold text-lg">Jenjang Pendidikan: {{ eosRecord.jenjang_pendidikan }}</span>
      </div>
      <form @submit.prevent="update(validationDoc)">
        <h3 class="pl-8 mt-6 text-2xl font-bold">
          1. Lembar Pengesahan Skripsi
        </h3>
        <div class="flex flex-wrap py-4 px-8">
          <text-input
            :value="eosRecord.validation_doc_num"
            class="pb-4 md:pr-6 w-full md:w-1/2"
            input-class="bg-gray-200"
            label="Nomor Lembar Pengesahan"
            disabled />
          <text-input
            :value="validationDocInfo"
            class="pb-4 w-full md:w-1/2"
            input-class="bg-gray-200 text-center font-bold"
            label="Status Verifikasi Lembar Pengesahan"
            disabled />
          <text-input
            v-model="validationDoc.validation_doc_verified_notes"
            class="pb-4 md:pr-6 w-full md:w-2/3"
            label="Keterangan Verifikasi" />
          <select-input
            v-model="validationDoc.validation_doc_verified"
            class="pb-4 w-full md:w-1/3"
            label="Status Lembar Pengesahan">
            <option :value="null">
              BELUM VERIF
            </option>
            <option :value="1">
              VERIF
            </option>
          </select-input>
        </div>
        <div class="flex px-8 pb-4 justify-between">
          <button
            v-if="eosRecord.validation_doc_file"
            class="btn-green"
            type="button"
            @click.prevent="showModal('validation_doc_file')">
            Lihat Gambar Scan Lembar Pengesahan
          </button>
          <text-input
            v-else
            value="File scan dokumen belum tersedia"
            class="w-full md:w-1/2"
            input-class="bg-red-300 text-center font-bold"
            disabled />
          <loading-button
            :loading="validationDoc.processing"
            class="btn-indigo"
            type="submit">
            Update Lembar Pengesahan
          </loading-button>
        </div>
      </form>
      <div class="divider" />
      <form @submit.prevent="update(diploma)">
        <h3 class="pl-8 mt-6 text-2xl font-bold">
          2. Lembar Ijazah
        </h3>
        <div class="flex flex-wrap py-4 px-8">
          <text-input
            :value="eosRecord.diploma_serial_num"
            class="pb-4 md:pr-6 w-full md:w-1/2"
            input-class="bg-gray-200"
            label="Nomor Ijazah"
            disabled />
          <text-input
            :value="diplomaInfo"
            class="pb-4 w-full md:w-1/2"
            input-class="bg-gray-200 text-center font-bold"
            label="Status Verifikasi Lembar Ijazah"
            disabled />
          <text-input
            v-model="diploma.diploma_verified_notes"
            class="pb-4 md:pr-6 w-full md:w-2/3"
            label="Keterangan Verifikasi" />
          <select-input
            v-model="diploma.diploma_verified"
            class="pb-4 w-full md:w-1/3"
            label="Status Lembar Ijazah">
            <option :value="null">
              BELUM VERIF
            </option>
            <option :value="1">
              VERIF
            </option>
          </select-input>
        </div>
        <div class="flex px-8 pb-4 justify-between">
          <button
            v-if="eosRecord.diploma_file"
            class="btn-green"
            type="button"
            @click.prevent="showModal('diploma_file')">
            Lihat Gambar Scan Lembar Ijazah
          </button>
          <text-input
            v-else
            value="File scan dokumen belum tersedia"
            class="w-full md:w-1/2"
            input-class="bg-red-300 text-center font-bold"
            disabled />
          <loading-button
            :loading="validationDoc.processing"
            class="btn-indigo"
            type="submit">
            Update Lembar Pengesahan
          </loading-button>
        </div>
      </form>
      <div class="divider" />
      <form @submit.prevent="update(academicTranscript)">
        <h3 class="pl-8 mt-6 text-2xl font-bold">
          3. Lembar Transkrip Nilai
        </h3>
        <div class="flex flex-wrap py-4 px-8">
          <text-input
            :value="academicTranscriptInfo"
            class="pb-4 w-full md:w-1/2"
            input-class="bg-gray-200 text-center font-bold"
            label="Status Verifikasi Lembar Pengesahan"
            disabled />
          <div class="w-full" />
          <text-input
            v-model="academicTranscript.academic_transcript_verified_notes"
            class="pb-4 md:pr-6 w-full md:w-2/3"
            label="Keterangan Verifikasi" />
          <select-input
            v-model="academicTranscript.academic_transcript_verified"
            class="pb-4 w-full md:w-1/3"
            label="Status Lembar Pengesahan">
            <option :value="null">
              BELUM VERIF
            </option>
            <option :value="1">
              VERIF
            </option>
          </select-input>
        </div>
        <div class="flex px-8 pb-4 justify-between">
          <button
            v-if="eosRecord.academic_transcript_file"
            class="btn-green"
            type="button"
            @click.prevent="showModal('academic_transcript_file')">
            Lihat Gambar Scan Lembar Transcript
          </button>
          <text-input
            v-else
            value="File scan dokumen belum tersedia"
            class="w-full md:w-1/2"
            input-class="bg-red-300 text-center font-bold"
            disabled />
          <loading-button
            :loading="academicTranscript.processing"
            class="btn-indigo"
            type="submit">
            Update Lembar Pengesahan
          </loading-button>
        </div>
      </form>
      <div class="divider" />
      <form @submit.prevent="update(eosVerify)">
        <h3 class="pl-8 mt-6 text-2xl font-bold">
          Kelayakan Pembayaran Akhir Studi
        </h3>
        <div class="flex flex-wrap py-4 px-8">
          <select-input
            v-model="eosVerify.approval_status_payment_id"
            class="pb-4 pr-6 w-full md:w-1/2"
            label="Persetujuan Pembayaran">
            <option :value="null" class="text-center">
              N/A
            </option>
            <option
              v-for="option in approvalStatusOptions"
              :key="option.id"
              :value="option.id">
              {{ option.status }}
            </option>
          </select-input>
          <select-input
            v-model="eosVerify.payment_status_id"
            class="pb-4 w-full md:w-1/2"
            label="Status Pembayaran">
            <option :value="null" class="text-center">
              N/A
            </option>
            <option
              v-for="option in paymentStatusOptions"
              :key="option.id"
              :value="option.id">
              {{ option.status }}
            </option>
          </select-input>
          <text-input
            v-model="eosVerify.payment_status_reason"
            class="pb-4 md:pr-6 w-full md:w-2/3"
            label="Keterangan Verifikasi" />
          <div class="w-full">
            <table class="table-fixed">
              <thead>
                <tr>
                  <th class="py-2 px-4 text-left text-light-blue-600 border-b">
                    No Transaksi
                  </th>
                  <th class="py-2 px-4 text-left text-light-blue-600 border-b">
                    Tanggal
                  </th>
                  <th class="py-2 px-4 text-right text-light-blue-600 border-b">
                    Jumlah
                  </th>
                  <th class="py-2 px-4 text-left text-light-blue-600 border-b">
                    Bank
                  </th>
                  <th class="py-2 px-4 text-right text-light-blue-600 border-b">
                    Status
                  </th>
                  <th />
                </tr>
              </thead>
              <tbody>
                <tr v-for="detail in eosPayments" :key="detail.id">
                  <td class="py-2 px-4 text-left">
                    {{ detail.payment_num }}
                  </td>
                  <td class="py-2 px-4 text-left">
                    {{ detail.payment_date }}
                  </td>
                  <td class="py-2 px-4 text-right">
                    {{ formatNumber(detail.payment_amount) }}
                  </td>
                  <td class="py-2 px-4 text-left">
                    {{ detail.bank }}
                  </td>
                  <td class="py-2 px-4 text-left">
                    {{ detail.status }}
                  </td>
                  <td class="py-2 px-4 text-right">
                    <a
                      :href="route('eos_payment.edit', detail.id)"
                      class="font-bold text-indigo-400 underline hover:text-indigo-600">Lihat</a>
                  </td>
                </tr>
                <tr v-if="eosPayments.length === 0">
                  <td class="py-4 px-6 border-t" colspan="6">
                    No payment data found.
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="flex px-8 pb-4 justify-between">
          <Link
            class="btn-green"
            as="button"
            :href="route('eos_payment.create', { eos_id: eosRecord.id })">
            Add Detail Pembayaran
          </Link>
          <loading-button
            :loading="eosVerify.processing"
            class="btn-indigo"
            type="submit">
            Update Kelayakan Pembayaran
          </loading-button>
        </div>
      </form>
    </div>
    <modal :is-modal-show="isModalVisible" @close="closeModal">
      <template slot="header">
        {{ modalTextHeader }}
      </template>
      <template slot="body">
        <div class="flex justify-center">
          <blob-image :src="imgUrl" />
        </div>
      </template>
    </modal>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import ToggleButton from '@/Shared/ToggleButton'
import Modal from '@/Shared/Modal'
import BlobImage from '@/Shared/BlobImage'
import Swal from 'sweetalert2'
import { Link, router, useForm } from '@inertiajs/vue2'
import { format, parseISO } from 'date-fns'

export default {
  metaInfo () {
    return {
      title: 'Verifikasi Akhir Studi',
    }
  },
  layout: Layout,
  components: {
    Link,
    TextInput,
    SelectInput,
    LoadingButton,
    ToggleButton,
    Modal,
    BlobImage,
  },
  props: {
    eosRecord: Object,
    eosPayments: Array,
    approvalStatusOptions: Array,
    paymentStatusOptions: Array,
  },
  computed: {
    validationDocInfo () {
      return this.eosRecord.validation_doc_verified === 1
        ? `VERIF : ${this.eosRecord.validation_doc_verified_at}`
        : 'BELUM VERIF'
    },
    diplomaInfo () {
      return this.eosRecord.diploma_verified === 1
        ? `VERIF : ${this.eosRecord.diploma_verified_at}`
        : 'BELUM VERIF'
    },
    academicTranscriptInfo () {
      return this.eosRecord.academic_transcript_verified === 1
        ? `VERIF : ${this.eosRecord.academic_transcript_verified_at}`
        : 'BELUM VERIF'
    },
  },
  data () {
    return {
      imgUrl: null,
      isModalVisible: false,
      modalTextHeader: 'Hasil Scan',
      isActive: this.eosRecord.is_active === 1,
      validationDoc: useForm({
        _method: 'put',
        _utype: 'validationDoc',
        validation_doc_verified: this.eosRecord.validation_doc_verified,
        validation_doc_verified_notes:
          this.eosRecord.validation_doc_verified_notes,
      }),
      diploma: useForm({
        _method: 'put',
        _utype: 'diploma',
        diploma_verified: this.eosRecord.diploma_verified,
        diploma_verified_notes: this.eosRecord.diploma_verified_notes,
      }),
      academicTranscript: useForm({
        _method: 'put',
        _utype: 'academicTranscript',
        academic_transcript_verified:
          this.eosRecord.academic_transcript_verified,
        academic_transcript_verified_notes:
          this.eosRecord.academic_transcript_verified_notes,
      }),
      eosVerify: useForm({
        _method: 'put',
        _utype: 'eosVerify',
        payment_status_id: this.eosRecord.payment_status_id,
        approval_status_payment_id: this.eosRecord.approval_status_payment_id,
        payment_status_reason: this.eosRecord.payment_status_reason,
      }),
    }
  },
  methods: {
    formatDate (date) {
      if (!date) return 'N/A'
      return format(parseISO(date), 'd MMM yyyy')
    },
    showModal (docType) {
      this.imgUrl = `/preview/${this.eosRecord[docType]}`
      this.isModalVisible = true
    },
    closeModal () {
      this.isModalVisible = false
    },
    update (form) {
      Swal.fire({
        title: 'Konfirmasi',
        text: 'Apakah anda yakin ingin mengupdate info verifikasi data?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes',
      }).then((result) => {
        if (result.isConfirmed) {
          form.post(this.route('eos.update', this.eosRecord.id), {
            preserveScroll: true,
          })
        }
      })
    },
    formatNumber (num) {
      return num ? num.toLocaleString('id-ID') : '0'
    },
  },
  watch: {
    isActive (newVal, oldVal) {
      if (newVal !== oldVal)
        router.post(this.route('eos.update', this.eosRecord.id), {
          _method: 'put',
          _utype: 'isActive',
          is_active: newVal ? 1 : 0,
        })
    },
  },
}
</script>
